import { useEffect } from 'react';
import type { MediaClient } from '@/features/meeting/media/contract';
import { isDesktopShell } from '../bridge';
import { registerDesktopMedia } from '../activeMedia';

/**
 * Lets global hotkeys reach the meeting room's media client.
 *
 * Called from the live room and nowhere else. Outside the desktop shell it does
 * nothing at all, so the meeting tree carries no desktop-specific behaviour in
 * a browser.
 */
export function useDesktopMediaBridge(client: MediaClient, micOn: boolean): void {
  useEffect(() => {
    if (!isDesktopShell()) return undefined;
    /* ONE CONTROL. `setTransmitting` was handed over here too, for the global
       push-to-talk gate; that gate is gone (apps/desktop/src/main/hotkeys.ts),
       and handing the published-track mute out of the room to nobody is a
       loaded weapon left on a table. `setMicEnabled` stops CAPTURE, which is
       what the global mute key wants and what the OS microphone indicator
       follows. */
    return registerDesktopMedia({
      micOn,
      setMicEnabled: (on) => {
        void client.setMicEnabled(on);
      },
    });
  }, [client, micOn]);
}
